import Swiper, { Pagination, Autoplay } from 'swiper';
import { $Q, $Qll } from '../utils/querySelector';
import 'swiper/css';
import { mediaQuery } from '../utils/mediaQuery';

class PhotographerOtherProfiles {
  constructor() {
    this.photographerOthersProfiles = $Q('.photographers-other-profiles');

    this.photographerOthersProfiles && this._init();
  }
  /**
   * Initialize PhotographerGallery feature
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */

  _init() {
    mediaQuery(
      '(max-width: 991px)',
      this._initPhotographerGallerySlider.bind(this)
    );
  }

  /**
   * Initialize PhotographerGallery slider with swiper slider
   * @author Daniel Santos <daniel.santos@gradiweb.com>
   */
  _initPhotographerGallerySlider() {
    this.slide = new Swiper('.photographers-other-profiles__slider', {
      modules: [Pagination],
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      pagination: {
        el: '.swiper-custom-pagination',
        clickable: true,
      },
    });
  }
}

export { PhotographerOtherProfiles };
